import { render } from "./HiSpinner.vue?vue&type=template&id=131d7052"
import script from "./HiSpinner.vue?vue&type=script&lang=js"
export * from "./HiSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__